

export enum CountryEnum {
    TURKEY = 1,
    UNITED_STATES_OF_AMERICA = 196
}
